export const searchData=[
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/rhode/rhode303391d3cd/rhode303391d3cd_1651071954047_2-0._UY0_QL90_.jpg",
        "title":"Rhode",
        "detail":"Astrid Dress",
        "price":"$445.00"
    },
  
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/tgrea/tgrea310111c925/tgrea310111c925_1649801064836_2-0._QL90_UX207_.jpg",
        "title":"THE GREAT.",
        "detail":"The Pathway Dress",
        "price":"$375.00"
    },
  
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/tgrea/tgrea310171d58a/tgrea310171d58a_1649802938404_2-0._QL90_UX207_.jpg",
        "title":"RAILS",
        "detail":"Ellis Button Down Shirt",
        "price":"$158.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/adina/adina2016711739/adina2016711739_q6_2-1._UX357_QL90_.jpg",
        "title":"Adina Reyter",
        "detail":"14k Gold Super Tiny Disc Necklace",
        "price":"$350.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/opttt/opttt3013117517/opttt3013117517_1649781693810_2-0._QL90_UX207_.jpg",
        "title":"OPT",
        "detail":"Tuscany Dress",
        "price":"$169.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/opttt/opttt301011071b/opttt301011071b_1630350841099_2-0._UX357_QL90_.jpg",
        "title":"",
        "detail":"Toile de Jouy Dress",
        "price":"$169.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/ullaj/ullaj2183012ce3/ullaj2183012ce3_1646756466341_2-0._QL90_UX207_.jpg",
        "title":"RAILS",
        "detail":"Gauze Ellis Shirt",
        "price":"$150.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/natio/natio1045186894/natio1045186894_1650396875804_2-0.jpg",
        "title":"Nation LTD",
        "detail":"Tuscany Dress",
        "price":"$168.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/sabmu/sabmu300011c925/sabmu300011c925_1650578129073_2-0._QL90_UX207_.jpg",
        "title":"Nation LTD",
        "detail":"Shoshanah Smocked Sundress",
        "price":"$198.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/mrive/mrive303431ac51/mrive303431ac51_1650492712605_2-0._QL90_UX207_.jpg",
        "title":"Tiered Midi Dress",
        "detail":"Sonali Bubble Hem Top",
        "price":"$150.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/tgrea/tgrea310171d58a/tgrea310171d58a_1649802938404_2-0._QL90_UX207_.jpg",
        "title":"OPT",
        "detail":"Gauze Ellis Shirt",
        "price":"$198.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/shosh/shosh417311d577/shosh417311d577_1649694180945_2-0.jpg",
        "title":"Moon River",
        "detail":"Tiered Midi Dress",
        "price":"$168.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/lvtla/lvtla300321e6f8/lvtla300321e6f8_1649275985144_2-0._QL90_UX207_.jpg",
        "title":"OPT",
        "detail":"Shoshanah Smocked Sundress",
        "price":"$169.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/xiren/xiren3061412244/xiren3061412244_1646948654189_2-0._QL90_UX207_.jpg",
        "title":"Moon River",
        "detail":"Hilma Dress",
        "price":"$398.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/natio/natio1044716a5e/natio1044716a5e_1650388437720_2-0._UY0_QL90_.jpg",
        "title":"LOVE THE LABEL",
        "detail":"Tiered Midi Dress",
        "price":"$150.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/natio/natio1045313f6e/natio1045313f6e_1650387982099_2-0._UX357_QL90_.jpg",
        "title":"THE GREAT.",
        "detail":"Shoshanah Smocked Sundress",
        "price":"$398.00"
    },
  
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/natio/natio1033910739/natio1033910739_q1_2-0._SH20_QL90_UY365_.jpg",
        "title":"Nation LTD",
        "detail":"Cameron Mock Neck Tee",
        "price":"$168.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/apiec/apiec303461d31b/apiec303461d31b_1649707055934_2-0._QL90_UX207_.jpg",
        "title":"THE GREAT.",
        "detail":"The Pleated Ravine Dress",
        "price":"$150.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/mrive/mrive3033016731/mrive3033016731_1648071054220_2-0._SH20_QL90_UY365_.jpg",
        "title":"Moon River",
        "detail":"Tiered Midi Dress",
        "price":"$198.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/mrive/mrive303341c925/mrive303341c925_1644444700529_2-0._SH20_QL90_UY365_PGshopbop-ep-sticker-3_UY365_.jpg",
        "title":"LOVE THE LABEL",
        "detail":"Hilma Dress",
        "price":"$425.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/natio/natio1045313f6e/natio1045313f6e_1650387983404_2-0._UY0_QL90_.jpg",
        "title":"Nation LTD",
        "detail":"The Pleated Ravine Dress",
        "price":"$398.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/lvtla/lvtla30036102ca/lvtla30036102ca_1649698109697_2-0._UX357_QL90_.jpg",
        "title":"LOVE THE LABEL",
        "detail":"Remy Dress",
        "price":"$265.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/lvtla/lvtla300241cd20/lvtla300241cd20_1641399011162_2-0._SH20_QL90_UY365_PGshopbop-ep-sticker-3_UY365_.jpg",
        "title":"En Saison",
        "detail":"Combination Ruched Dress",
        "price":"$265.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/lvtla/lvtla300191cd1d/lvtla300191cd1d_1639078962739_2-0._UX357_QL90_.jpg",
        "title":"MISA",
        "detail":"Luella Tiered Skirt",
        "price":"$132.50 "
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/lvtla/lvtla300221cd1b/lvtla300221cd1b_1644006685926_2-0._SH20_QL90_UY365_.jpg",
        "title":"En Saison",
        "detail":"Remy Dress",
        "price":"$265.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/lvtla/lvtla30036102ca/lvtla30036102ca_1649698109766_2-0._QL90_UX207_.jpg",
        "title":"LOVE THE LABEL",
        "detail":"Remy Dress",
        "price":"$167.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/ensai/ensai300961b002/ensai300961b002_1631125185078_2-0._UX357_QL90_.jpg",
        "title":"MISA",
        "detail":"Combination Ruched Dress",
        "price":"$94.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/pcs/shopbop/media/desktop/mastheads/seo/sb_20220421_desktop_BRANDSEO_MH_misa_1-0.jpg",
        "title":"LOVE THE LABEL",
        "detail":"Detail Midi Dress",
        "price":"$132.50"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/tbags/tbags410881d73f/tbags410881d73f_1649693825527_2-0._SH20_QL90_UY365_.jpg",
        "title":"Apiece Apart",
        "detail":"Vida Dress",
        "price":"$265.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/ensai/ensai301481c3c8/ensai301481c3c8_1645823217415_2-0._UX357_QL90_.jpg",
        "title":"MISA",
        "detail":"Remy Dress",
        "price":"$167.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/tbags/tbags410891d73a/tbags410891d73a_1649693830785_2-0._UY0_QL90_.jpg",
        "title":"LOVE THE LABEL",
        "detail":"Remy Dress",
        "price":"$265.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/ensai/ensai3016010dad/ensai3016010dad_1642096267009_2-0._SH20_QL90_UY365_PGshopbop-ex-sticker-3_UY365_.jpg",
        "title":"En Saison",
        "detail":"Maya Dress",
        "price":"$132.50"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/tbags/tbags410901d73b/tbags410901d73b_1649684062808_2-0._UX357_QL90_.jpg",
        "title":"MISA",
        "detail":"Vida Dress",
        "price":"$94.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/ensai/ensai301301c3a0/ensai301301c3a0_1636060878910_2-0._SH20_QL90_UY365_.jpg",
        "title":"En Saison",
        "detail":"Remy Dress",
        "price":"$265.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/ensai/ensai30150172fb/ensai30150172fb_1647532652702_2-0._SH20_QL90_UY365_.jpg",
        "title":"LOVE THE LABEL",
        "detail":"Maya Dress",
        "price":"$470.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/ensai/ensai30162102cb/ensai30162102cb_1637018390346_2-0._SH20_QL90_UY365_.jpg",
        "title":"byTiMo",
        "detail":"Cotton Slub Button Down Dress",
        "price":"$295.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/lvtla/lvtla300281d446/lvtla300281d446_1649196278881_2-0._SH20_QL90_UY365_.jpg",
        "title":"byTiMo",
        "detail":"Andromeda Dress",
        "price":"$295.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/seaaa/seaaa215381a569/seaaa215381a569_1647377477768_2-0._QL90_UX207_.jpg",
        "title":"Apiece Apart",
        "detail":"Bjorn Dress",
        "price":"$371.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/cultg/cultg307991a924/cultg307991a924_1651163728418_2-0._UX357_QL90_.jpg",
        "title":"CULT GAIA",
        "detail":"Catherine Knit Sweater",
        "price":"$388.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/tgrea/tgrea310141d58b/tgrea310141d58b_1649865636053_2-0._QL90_UX207_.jpg",
        "title":"byTiMo",
        "detail":"Andromeda Dress",
        "price":"$295.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/celia/celia300911c3c8/celia300911c3c8_1651092366708_2-0._SH20_QL90_UY365_.jpg",
        "title":"XIRENA",
        "detail":"Cotton Slub Button Down Dress",
        "price":"$295.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/apiec/apiec303401d316/apiec303401d316_1647276498608_2-0._QL90_UX346_.jpg",
        "title":"Apiece Apart",
        "detail":"Mini Mitte Dress",
        "price":"$283.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/ensai/ensai301401a561/ensai301401a561_1642538171190_2-0._QL90_UX346_.jpg",
        "title":"byTiMo",
        "detail":"Viggo Romper",
        "price":"$413.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/apiec/apiec303441d317/apiec303441d317_1647288532218_2-0._UX357_QL90_.jpg",
        "title":"Apiece Apart",
        "detail":"Verder Mini Dress",
        "price":"$295.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/velve/velve4155610213/velve4155610213_1643138200642_2-0._QL90_UX346_.jpg",
        "title":"CULT GAIA",
        "detail":"Cotton Slub Button Down Dress",
        "price":"$388.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/celia/celia300921c925/celia300921c925_1651162954622_2-0._SH20_QL90_UY365_.jpg",
        "title":"CULT GAIA",
        "detail":"Andromeda Dress",
        "price":"$295.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/celia/celia300841c3c8/celia300841c3c8_1648500171817_2-0._QL90_UX207_.jpg",
        "title":"CELIAB",
        "detail":"Bjorn Dress",
        "price":"$371.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/bytim/bytim300841d3a8/bytim300841d3a8_1648043252240_2-0._UX357_QL90_.jpg",
        "title":"byTiMo",
        "detail":"Verder Mini Dress",
        "price":"$388.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/bytim/bytim300841d3a8/bytim300841d3a8_1648043252240_2-0._UX357_QL90_.jpg",
        "title":"CELIAB",
        "detail":"Cotton Slub Button Down Dress",
        "price":"$413.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/rails/rails3145021145/rails3145021145_1645809649004_2-0._QL90_UX207_.jpg",
        "title":"byTiMo",
        "detail":"Verder Mini Dress",
        "price":"$295.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/apiec/apiec303461d31b/apiec303461d31b_1649707056864_2-0._UX357_QL90_.jpg",
        "title":"Apiece Apart",
        "detail":"Mini Mitte Dress",
        "price":"$388.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/celia/celia30077102c9/celia30077102c9_1640212398591_2-0._UX357_QL90_.jpg",
        "title":"CELIAB",
        "detail":"Verder Mini Dress",
        "price":"$413.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/ensai/ensai301401a561/ensai301401a561_1642538171190_2-0._QL90_UX207_.jpg",
        "title":"XIRENA",
        "detail":"Aurie Dress",
        "price":"$283.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/celia/celia300871c3c8/celia300871c3c8_1651098253454_2-0._SH20_QL90_UY365_.jpg",
        "title":"CULT GAIA",
        "detail":"Shoshanah Smocked Sundress",
        "price":"$295.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/celia/celia300901c3c8/celia300901c3c8_1649102555214_2-0._SH20_QL90_UY365_.jpg",
        "title":"Apiece Apart",
        "detail":"Bjorn Dress",
        "price":"$371.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/wayfa/wayfa205081d036/wayfa205081d036_1645565360908_2-0._SH20_QL90_UY365_.jpg",
        "title":"byTiMo",
        "detail":"Gaya Dress",
        "price":"$388.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/wayfa/wayfa204951c5f0/wayfa204951c5f0_1637705736133_2-0._SH20_QL90_UY365_.jpg",
        "title":"XIRENA",
        "detail":"Malibu Faux Wrap Midi Dress",
        "price":"$295.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/celia/celia300881c3c8/celia300881c3c8_1648489949874_2-0._SH20_QL90_UY365_.jpg",
        "title":"Apiece Apart",
        "detail":"Malibu Faux Wrap Midi Dress",
        "price":"$413.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/wayfa/wayfa2039113149/wayfa2039113149_q1_2-0._SH20_QL90_UY365_.jpg",
        "title":"CELIAB",
        "detail":"Aurie Dress",
        "price":"$371.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/wayfa/wayfa2050912424/wayfa2050912424_1649956616919_2-0._SH20_QL90_UY365_.jpg",
        "title":"CULT GAIA",
        "detail":"Bjorn Dress",
        "price":"$388.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/wayfa/wayfa205071d034/wayfa205071d034_1645565347341_2-0._SH20_QL90_UY365_.jpg",
        "title":"byTiMo",
        "detail":"Shoshanah Smocked Sundress",
        "price":"$99.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/wayfa/wayfa2047412466/wayfa2047412466_1633121844836_2-0._SH20_QL90_UY365_.jpg",
        "title":"XIRENA",
        "detail":"Gaya Dress",
        "price":"$198.00"
    },
    {
        "image":"https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/rhode/rhode303391d3cd/rhode303391d3cd_1651071952963_2-0._UX357_QL90_.jpg",
        "title":"CELIAB",
        "detail":"Aurie Dress",
        "price":"$283.00"
    }
  
  
]